import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-core";
import { PaymentGroupDataDef, FlipkartSuperCoinsPaymentGroup } from "@swiggy-private/payment-ui";

export function isFlipkartSuperCoinsGroup(
    group: PaymentGroupDataDef,
): group is FlipkartSuperCoinsPaymentGroup["paymentData"] {
    return group.groupName.toUpperCase() === VALID_PAYMENT_GROUP_TYPES.FLIPKART_SUPER_COIN;
}
